/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const addMountedNudge =
	(nudge: string): Action<State> =>
	({ getState, setState }) => {
		const { mountedNudges } = getState();

		// skip store update if this nudge is already added
		if (mountedNudges.includes(nudge)) {
			return;
		}

		setState({ mountedNudges: [...mountedNudges, nudge] });
	};

export const removeMountedNudge =
	(nudge: string): Action<State> =>
	({ getState, setState }) => {
		const { mountedNudges } = getState();

		// skip store update if this nudge is already removed
		if (!mountedNudges.includes(nudge)) {
			return;
		}

		setState({ mountedNudges: mountedNudges.filter((mountedNudge) => mountedNudge !== nudge) });
	};
